import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';

export interface BankDataSectorSummary {
  id: number;
  slug: string;
  name: string;
  order_index: number;
}

export interface BankDataJobDescription {
  id: number;
  name: string;
  order_index: number;
  reports: string[];
}

export interface BankDataKeyActivity {
  id: number;
  name: string;
  order_index: number;
  job_descriptions: BankDataJobDescription[];
}

export interface BankDataJabatan {
  id: number;
  name: string;
  order_index: number;
  key_activities: BankDataKeyActivity[];
}

export interface BankDataSectorTree {
  id: number;
  slug: string;
  name: string;
  order_index: number;
  jabatans: BankDataJabatan[];
}

export interface MatchSectorsResponse {
  matched: BankDataSectorSummary[];
  fallback_used: boolean;
}

export interface MatchSectorsParams {
  industry: string;
  category: string;
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

export async function matchSectors({ industry, category }: MatchSectorsParams): Promise<MatchSectorsResponse> {
  const url = `${env.apiTasklistBaseUrl}/api/v1/compro/bank-data/sectors/match`;
  const { data } = await axiosInstance.get<ApiEnvelope<MatchSectorsResponse>>(url, {
    params: { industry, category },
  });
  return data.data;
}

export async function getSectorTree(sectorId: number): Promise<BankDataSectorTree> {
  const url = `${env.apiTasklistBaseUrl}/api/v1/compro/bank-data/sectors/${sectorId}/tree`;
  const { data } = await axiosInstance.get<ApiEnvelope<BankDataSectorTree>>(url);
  return data.data;
}
